import React, { useState, useEffect, useRef } from 'react';

const SessionTimer = ({ children, handleLogout }) => {
    const [showAlert, setShowAlert] = useState(false);
    const [remainingTime, setRemainingTime] = useState(60);
    const countdownRef = useRef(null);
    const idleTimeoutRef = useRef(null);
    const idleTimeLimit = 5 * 60 * 1000;
    // const isMounted = useRef(true);

    // const handleLogout = async () => {
    //     alert("Logged out successfully");
    // };

    const startCountdown = () => {
        if (countdownRef.current) return;
        countdownRef.current = setInterval(() => {
            setRemainingTime(prev => {
                if (prev <= 1) {
                    clearInterval(countdownRef.current);
                    countdownRef.current = null;
                    // if (isMounted.current)
                    handleLogout();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const resetIdleTimer = () => {
        clearTimeout(idleTimeoutRef.current);
        if (countdownRef.current) {
            clearInterval(countdownRef.current);
            countdownRef.current = null;
        }

        setShowAlert(false);
        setRemainingTime(60);

        idleTimeoutRef.current = setTimeout(() => {
            setShowAlert(true);
            startCountdown();
            removeEventListeners();
        }, idleTimeLimit);
    };

    const extendSession = () => {
        // if (!isMounted.current) return;
        setShowAlert(false);
        resetIdleTimer();
        addEventListeners();
    };

    const convertSecondsToMinSec = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes} minutes ${remainingSeconds} seconds`;
    };

    const handleUserActivity = () => {
        resetIdleTimer();
    };

    const addEventListeners = () => {
        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
        events.forEach(event => window.addEventListener(event, handleUserActivity));
    };

    const removeEventListeners = () => {
        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
        events.forEach(event => window.removeEventListener(event, handleUserActivity));
    };

    useEffect(() => {
        resetIdleTimer();
        addEventListeners();

        return () => {
            removeEventListeners();
            clearInterval(countdownRef.current);
            clearTimeout(idleTimeoutRef.current);
            // isMounted.current = false;
        };
    }, []);

    return (
        <div>
            {children}
            {showAlert && (
                <div className="inactivity-modal-overlay">
                    <div className="inactivity-modal">
                        <h2>You have been inactive for more than 3 minutes!</h2>
                        <p>Remaining time: {convertSecondsToMinSec(remainingTime)}</p>
                        <div className="inactivity-modal-actions">
                            <button className="stay-logged-in-btn" onClick={extendSession}>
                                Extend Session
                            </button>
                        </div>
                    </div>

                </div>
            )}

        </div>
    );
};

export default SessionTimer;
